import { z } from "zod";
import { CommunityKudosFeedItem } from "./kudos.js";
import { CommunityMilestoneFeedItem } from "./milestone.js";
import { CommunityMomentFeedItem } from "./moment.js";
import { CommunityCompany, CommunityPreferences, CommunitySettings } from "./settings.js";
import { WeeklyRecipeFeedItem } from "./weekly-recipe.js";
export const CommunityFeedItem = z.discriminatedUnion("type", [
    CommunityMomentFeedItem,
    CommunityKudosFeedItem,
    CommunityMilestoneFeedItem,
    WeeklyRecipeFeedItem,
]);
export const CommunityStat = z.object({
    id: z.enum(["moments_acted", "teammates_showing_up", "kudos_sent"]),
    label: z.string(),
    value: z.number().int().nonnegative().nullable(),
    hiddenForPrivacy: z.boolean(),
});
// Empty by design: `/api/community` returns one endless feed. Zod strips old
// scope/weekStart params so older clients keep working while new callers do
// not get a typed weekly feed option.
export const GetCommunityQuery = z.object({});
export const GetCommunityResponse = z.object({
    company: CommunityCompany,
    settings: CommunitySettings,
    preferences: CommunityPreferences,
    weekStart: z.string(),
    weekEnd: z.string(),
    stats: z.array(CommunityStat),
    feed: z.array(CommunityFeedItem),
});
//# sourceMappingURL=feed.js.map